
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Time Slots Component
 * @param response has the backend
 * Time Slots component response
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    let result: any = {
        timeslots: [],
        error: undefined
    }

    const { log } = context;
    
    // Log the raw response for debugging
    log.debug(
        "ccw-gadget,getalltimeslots-athena",
        "getalltimeslots-athena raw response", {
        response
    });
    
    if (response && response.status >= 400) {
        result.error = response;
    } else if (response?.results && Array.isArray(response.results)) {
        result.timeslots = response.results;
    } else if (Array.isArray(response)) {
        // Handle case where response is directly an array
        result.timeslots = response;
    } else if (response?.data?.results && Array.isArray(response.data.results)) {
        // Handle case where results are nested under data
        result.timeslots = response.data.results;
    }
    
    log.debug(
        "ccw-gadget,getalltimeslots-athena",
        "getalltimeslots-athena transformation result", {
        timeslotsCount: result.timeslots?.length || 0,
        hasError: !!result.error,
        result
    });
    
    return result;
}
